module.exports = __webpack_public_path__ + "static/media/menuIcon.09a3f8d7.svg";